import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  get_classroom,
  add_classroom,
  update_classroom,
  delete_classroom,
} from "../Service/ApiServices.js";
import { toast } from "react-toastify";

const initialState = {
  classrooms: [],
  school_id: "",
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
school_class:"" , 
section:"",
subject:"",
room:""  
  },
};

// Async Thunks for API Calls
export const fetchclassroom = createAsyncThunk(
  "classroom/fetchclassroom",
  async (
    {school_id, token, signal },
    { rejectWithValue }
  ) => {
    try {
      const response = await get_classroom(
        school_id,
        token,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createclassroom = createAsyncThunk(
  "classroom/createclassroom",
  async ({ data, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_classroom(data, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateclassroom = createAsyncThunk(
  "classroom/updateclassroom",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_classroom(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteclassroom = createAsyncThunk(
  "classroom/deleteclassroom",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_classroom({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Class Slice
const classroomSlice = createSlice({
  name: "classrooms",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    updateFilterData(state, action) {
        const { name, value } = action.payload;
        state.filterData[name] = value;
      },
    EditFormData(state, action) {
      // The action should contain all the fields that need to be updated
      const {
        id,
       
      } = action.payload;
      state.formData = {
        id,
      };
    },
    resetFormData(state) {
      state.formData = {
        school_class:"" , 
        section:"",
        subject:"",
        room:"" 
      };
    },
    setclassroom(state, action) {
      state.classrooms = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
   
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
   
      .addCase(fetchclassroom.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchclassroom.fulfilled, (state, action) => {
        state.loading = false;
        state.classrooms = action?.payload;
      })
      .addCase(fetchclassroom.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.classrooms = [];

      })

      // Add Class
      .addCase(createclassroom.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createclassroom.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createclassroom.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update Class
      .addCase(updateclassroom.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateclassroom.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateclassroom.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;

        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete Class
      .addCase(deleteclassroom.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteclassroom.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteclassroom.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  setclassroom,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  updateFilterData,

} = classroomSlice.actions;
export default classroomSlice.reducer;




